import React, { useState, useEffect } from 'react';

const CounterOrderIsolated = () => {
  const [renderCount, setRenderCount] = useState(0);
  const [logs, setLogs] = useState([]);

  const addLog = (message) => {
    const timestamp = new Date().toLocaleTimeString();
    setLogs(prev => [...prev.slice(-10), `${timestamp}: ${message}`]);
  };

  // Track every render
  useEffect(() => {
    setRenderCount(prev => {
      const newCount = prev + 1;
      addLog(`Component rendered #${newCount}`);
      return newCount;
    });
  }, []);

  // Simple effect with no dependencies
  useEffect(() => {
    addLog('Component mounted');
    return () => addLog('Component unmounting');
  }, []);

  // Effect with state dependency (potential loop source)
  useEffect(() => {
    addLog('Render count changed: ' + renderCount);
  }, [renderCount]);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold mb-4">Isolated Counter Order Test</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-gray-50 p-4 rounded">
            <h3 className="font-semibold mb-2">Render Stats</h3>
            <p><strong>Render Count:</strong> {renderCount}</p>
            <p><strong>Status:</strong> {renderCount > 50 ? '🔴 Potential Loop' : renderCount > 10 ? '🟡 High Activity' : '🟢 Normal'}</p>
          </div>
          
          <div className="bg-gray-50 p-4 rounded">
            <h3 className="font-semibold mb-2">Component Logs</h3>
            <div className="max-h-32 overflow-y-auto text-xs">
              {logs.map((log, index) => (
                <div key={index} className="text-gray-600">{log}</div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-4 bg-blue-50 p-4 rounded">
          <h3 className="font-semibold text-blue-800 mb-2">Test Results</h3>
          {renderCount <= 5 && (
            <p className="text-green-600">✅ Component is stable - no infinite loops detected</p>
          )}
          {renderCount > 5 && renderCount <= 20 && (
            <p className="text-yellow-600">⚠️ Moderate re-rendering - check useEffect dependencies</p>
          )}
          {renderCount > 20 && (
            <p className="text-red-600">❌ Excessive re-rendering detected - infinite loop likely</p>
          )}
        </div>

        <div className="mt-4 bg-yellow-50 p-4 rounded">
          <h3 className="font-semibold text-yellow-800 mb-2">Instructions</h3>
          <p className="text-sm text-yellow-700">
            This isolated component tests basic React rendering without Redux or complex logic.
            If this freezes, the issue is fundamental. If not, the problem is in the CounterOrder component.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CounterOrderIsolated;
